import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Link, type LinkProps } from "@/components/ui/link";
import { cn } from "@/lib/utils";

export interface CtaLinkProps extends Omit<LinkProps, "variant"> {
  icon?: ReactNode;
}

/**
 * Overrides on top of the accent `Button`:
 * - `rounded-pill`: a deliberate exception, it must not move up to the primitive;
 * - `text-body-sm font-semibold`: `size="lg"` alone would compete in line height with the nav;
 * - `shadow-cta`: the system shadows are navy and made for light surfaces.
 */
export const CtaLink: FC<CtaLinkProps> = ({
  icon = <ChevronRight />,
  className,
  children,
  ...props
}) => (
  <Button
    asChild
    size="lg"
    variant="accent"
    className={cn("rounded-pill text-body-sm font-semibold shadow-cta", className)}
  >
    <Link {...props} className="no-underline hover:no-underline">
      {children}
      {icon && (
        <span aria-hidden className="flex shrink-0 [&>svg]:h-4 [&>svg]:w-4">
          {icon}
        </span>
      )}
    </Link>
  </Button>
);

CtaLink.displayName = "CtaLink";
